import type { ValidateMessages } from 'ant-design-vue/lib/form/interface'

export const antValidateMessages: ValidateMessages = {
	required: '${label} is required!',
	types: {
		email: '${label} is not a valid email!',
		number: '${label} is not a valid number!'
	},
	number: {
		min: '${label} must be at least ${min} characters',
		max: '${label} must be at most ${max} characters'
	},
	string: {
		min: '${label} must be at least ${min} characters',
		max: '${label} must be at most ${max} characters',
		len: '${label} must be ${len} characters long',
		range: '${label} must be between ${min} and ${max} characters long'
	}
}
export function chunkArray<T>(arr: T[], size: number = 3): T[][] {
	const chunked: T[][] = []
	for (let i = 0; i < arr.length; i += size) {
		chunked.push(arr.slice(i, i + size))
	}
	return chunked
}
export function reduceArray<T>(arr: T[], start = 0, size: number = 4): T[] {
	return arr.slice(start, size)
}
